import { useTheme } from '@mui/joy';

export const SiflyLogo = () => {
  const theme = useTheme();
  return theme.palette.mode === 'dark' ? '/images/logos/siflyLogo.svg' : '/images/logos/siflyBlackLogo.png';
};
